import $http from './http'
import config from './config'

export default {
  name: 'train',
  CheckRepeatOrder(data) {
    return $http.post(this.getUrl('/TrainOrder/CheckRepeatOrder'), data, {
        failTips: false
    });
  },
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getCreateOrder(data) {
    return $http.post(this.getUrl(`/TrainOrder/CreateOrder`), data);
  },
  ConsumerVerification(data) {
    return $http.post(this.getUrl(`/TrainOrder/ConsumerVerification`), data);
  },
  OrderDetails(UniqueID) {
    return $http.get(this.getUrl(`/TrainOrder/OrderDetails?UniqueID=${UniqueID}`));
  },
  RefundJudge(UniqueID) {
    return $http.get(this.getUrl(`/TrainOrder/RefundJudge?UniqueID=${UniqueID}`));
  },
  CreateAmend(amend) {
    return $http.post(this.getUrl(`/TrainOrder/CreateAmend`), amend)
  },
  OrderChange(data) {
    return $http.post(this.getUrl('/TrainOrder/TrainOrderChange'), data);
  },
  OrderCancel(id) {
    return $http.get(this.getUrl(`/TrainOrder/OrderCancel?UniqueID=${id}`));
  },
  OrderSubmit(UniqueID) {
    return $http.get(this.getUrl(`/TrainOrder/OrderSubmit/${UniqueID}`));
  },
  UpdateOrderStatus(id) {
    return $http.get(this.getUrl(`/TrainOrder/UpdateOrderStatus?UniqueID=${id}`));
  },
  OrderRefund(data) {
    return $http.post(this.getUrl('/TrainOrder/OrderRefund'), data);
  },
  SearchOrders(id) {
    return $http.get(this.getUrl(`/TrainOrder/SearchOrders?UniqueID=${id}`));
  },
  OrderRefundCancel(id) {
    return $http.get(this.getUrl(`/TrainOrder/OrderRefundCancel?UniqueID=${id}`));
  },
  GetSimpleOrder(id){
    return $http.get(this.getUrl(`/TrainOrder/GetSimpleOrder?UniqueID=${id}`));
  }
}



// WEBPACK FOOTER //
// ./src/apis/trainApis.js